<script lang="ts">
  import { Button, Col, Container, Row } from "sveltestrap";
  import BookmarkDefaultstyle from "./BookmarkDefaultstyle.svelte";
  import Card from "../../Core/Card.svelte";
  import LargeButton from "./LargeButton.svelte";
  import SmallButton from "./SmallButton.svelte";
  import ExtraSmallButton from "./ExtraSmallButton.svelte";
  import ActiveButton from "./ActiveButton.svelte";
  import CustomButton from "./CustomButton.svelte";
  import OutlineButton from "./OutlineButton.svelte";
  import BoldOutlineButton from "./BoldOutlineButton.svelte";
  import OutlineLargeButton from "./OutlineLargeButton.svelte";
  import OutlinSmallButton from "./OutlinSmallButton.svelte";
  import OutlineExtraSmallButton from "./OutlineExtraSmallButton.svelte";
  import DisableOutlineButton from "./DisableOutlineButton.svelte";
  import GradientButton from "./GradientButton.svelte";
  import data from "../../../Data/ComponentData/BonusUi/BonusUi.json"
  import { DefaultButtons, PrimaryButton, Sveltestrapstatebuttons } from "../../../utils/Constant/Constant";
  import DisableButton from "./DisableButton.svelte";

</script>
<BookmarkDefaultstyle />
<Container fluid>
    <Row>
      <Col sm="12">
        <Card headerTitle="{DefaultButtons}" cardHeaderprops="pb-0" cardBodyprops="btn-showcase">
          <div slot="customheader">
            <span>{Sveltestrapstatebuttons}</span>
          </div>
          <div slot="contentbody">
              <Button color="primary">{PrimaryButton}</Button>
              {#each data.buttoncolordata as buttonItem}
                <Button color={buttonItem.color}>{buttonItem.title} Button</Button>
              {/each}
          </div>
        </Card>
        <LargeButton />
        <SmallButton />
        <ExtraSmallButton />
        <ActiveButton />
        <DisableButton />
        <CustomButton />
        <OutlineButton />
        <BoldOutlineButton />
        <OutlineLargeButton />
        <OutlinSmallButton />
        <OutlineExtraSmallButton />
        <DisableOutlineButton />
        <GradientButton />
      </Col>
    </Row>
</Container>
  